module.exports = __webpack_public_path__ + "img/up-to-40-discount-img.9fd58df4.png";